/**
 * orga app | api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CommandFailedNotification { 
    notification_type?: string;
    command_id?: string;
    command_type?: string;
    request_id?: string;
    trace_identifier?: string;
    object_type?: string;
    object_id?: string;
    error_text?: string;
    user_id?: string;
}

